module.exports = "https://static.energy5.com/_next/static/images/map-35b0aa21648567cae0a6a5cdf7838eae.png";